import { studioApiSdk } from '@/lib/fetcher'
import { StudioSnippet, StudioSnippetFilterData } from '@/features/snippets'

export const getSnippets = async (filter: StudioSnippetFilterData): Promise<StudioSnippet[]> => {
  return studioApiSdk.getSnippets(filter)
}

export const createSnippet = async (snippet: StudioSnippet): Promise<StudioSnippet> => {
  return studioApiSdk.createSnippet(snippet)
}

export const updateSnippet = async (snippet: StudioSnippet & { id: number }): Promise<StudioSnippet> => {
  return studioApiSdk.updateSnippet(snippet.id, snippet)
}

export const getSnippet = async (id: number): Promise<any> => {
  return studioApiSdk.getSnippet(id)
}
